/* Lawnbest V16: reliable native Shopify add-to-cart submission.
   We intentionally do not intercept product form submits with AJAX.
   Shopify's native product form POST is the most reliable path across
   desktop, iOS, Android, and theme-editor preview environments. */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      if (!this.form) return;

      // Shrine renders the selected variant input disabled and normally
      // relies on JavaScript to re-enable it. Always enable it so Shopify
      // receives a valid variant ID during native form submission.
      const idInput = this.form.querySelector('[name="id"]');
      if (idInput) idInput.disabled = false;

      // Re-check immediately before every native submit. This also covers
      // sticky Add to Cart buttons that submit the form via the form="..." attr.
      this.form.addEventListener('submit', () => {
        const currentIdInput = this.form.querySelector('[name="id"]');
        if (currentIdInput) currentIdInput.disabled = false;
      });
    }

    // Variant-picker code in Shrine calls this method when variant state changes.
    // Keep it available even though native form submission handles cart errors.
    handleErrorMessage(errorMessage = false) {
      const wrapper = this.querySelector('.product-form__error-message-wrapper');
      if (!wrapper) return;
      const message = wrapper.querySelector('.product-form__error-message');
      wrapper.toggleAttribute('hidden', !errorMessage);
      if (message && errorMessage) message.textContent = errorMessage;
    }
  });
}
